import Amplify from '@aws-amplify/core'
import React from 'react'
import ReactDOM from 'react-dom'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './authConfig'
import { COGNITO } from './configs/aws'
import App from './App'
import AWS from 'aws-sdk'
;(async () => {
  /**
   * Initialize AWS configuration before initializing the App
   * */
  // await Amplify.configure(COGNITO)
  await Amplify.configure(COGNITO)
  const getCredentials = async () => {
    AWS.config.region = 'us-east-1'
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: 'us-east-1:be4d4940-c080-4b64-b73a-2aaeb9204826',
    })

    return new Promise((resolve, reject) => {
      AWS.config.getCredentials(async function (err) {
        if (err) {
          console.log(err)
          return reject(err)
          // eslint-disable-next-line
        } else {
          resolve({
            accessKeyId: AWS.config.credentials ? AWS.config.credentials.accessKeyId : '',
            secretAccessKey: AWS.config.credentials ? AWS.config.credentials.secretAccessKey : '',
            sessionToken: AWS.config.credentials ? AWS.config.credentials.sessionToken : '',
          })
        }
      })
    })
  }
  const init = async () => {
    const creds = await getCredentials()
    const msalInstance = new PublicClientApplication(msalConfig)

    ReactDOM.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App credentials={creds} />
        </MsalProvider>
      </React.StrictMode>,
      document.getElementById('root'),
    )
  }
  init()
})()
